export default __webpack_public_path__ + "static/media/awc-grey.9a7b959d.svg";